// components/ShinyMenuItem.tsx
import React from "react";

interface ShinyMenuItemProps {
  icon: React.ReactNode;
  label: string;
  className?: string;
}

export const ShinyMenuItem: React.FC<ShinyMenuItemProps> = ({ icon, label, className }) => (
  <span
    style={{
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      overflow: "hidden",
      // background: "linear-gradient(135deg, #fff1f2 0%, #fecdd3 100%)",
      background: "linear-gradient(135deg, #faf5ff 0%, #e9d5ff 100%)",
      // color: "#9f1239",
      color: "#6b21a8",
      fontWeight: 600,
      fontSize: 14,
      borderRadius: 6,
      padding: "3px 10px 3px 6px",
      // boxShadow: "0 0 0 1px #fda4af33",
      boxShadow: "0 0 0 1px #c084fc33",
    }}
    className={className}
  >
    {/* Icon */}
    <span style={{ display: "flex", fontSize: 15 }}>{icon}</span>

    {/* Label text */}
    {label}

    {/* Shine beam */}
    <span
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "45%",
        height: "100%",
        background: "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.65) 50%, transparent 100%)",
        animation: "shinyBeam 2.4s ease-in-out infinite",
        pointerEvents: "none",
      }}
    />
  </span>
);
